import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class FlowAbility extends Ability {
  @service declare authz: AuthzService;

  get canEditAllLocation(): boolean {
    return this.authz.hasPermissionAtCurrentCompany(Permission.VISITORS_FLOW_UPDATE);
  }
}
